module.exports = __webpack_public_path__ + "img/Truce_Black.b5dbf0ea.png";